// extracted by mini-css-extract-plugin
export var label = "_7s-1";
export var reminder = "_7s-0";